import "../css/CommonDesign.css";
import { Stepper, Step, StepLabel, Container, Stack, Button, Breadcrumbs, Typography, Link } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import MenuMenu from "./MenuMenu";

const steps = [
  '情報入力',
  '内容の確認',
  '完了',
];

const D0043ContactComplete = () => {

  return (
    <>
      <MenuMenu sel={0} />

      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg" style={{paddingLeft:"0", paddingRight:"0"}}>
                <Stack spacing={2}>

                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                  >
                    <Link underline="hover" key="1" color="inherit" href="./" style={{fontSize:"14px"}}>
                      TOP
                    </Link>,
                    <Typography key="2" color="text.primary" style={{fontSize:"14px"}}>
                      お問合せ　
                    </Typography>,
                    {/* <Typography key="3" color="text.primary">
                      お問合せ　内容確認
                    </Typography>, */}
                    {/* <Typography key="4" color="text.primary">
                      お問合せ　完了
                    </Typography> */}
                  </Breadcrumbs>

                  <h1>お問合せ</h1>
                  <Stepper activeStep={2} alternativeLabel>
                    {steps.map((label) => (
                      <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                      </Step>
                    ))}
                  </Stepper>

                  <div className="d0043_complete">
                    <b>お問い合わせを送信しました。</b><br /><br />
                    後日、土日祝日を除く開庁時間中に担当から回答します。<br />
                    また、回答に時間を要する場合がありますので、ご了承ください。
                  </div>

                  <div
                    style={{
                      display: "flex"
                      , justifyContent: "center"
                      , position: "relative"
                      , flexWrap: "wrap"
                      , marginTop: "40px"
                      , marginBottom: "40px"
                    }}>
                    <input type="button"
                      class="decision_button"
                      onClick={() => window.location.href="./"}
                      value="トップページへ" />
                  </div>

                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default D0043ContactComplete;